import React from "react";
import AddTurnoForm from "./AddTurnoForm";

const AddTurno = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Turno"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddTurnoForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddTurno;
